var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import League from './PopularLeagues';
import { leagueSortFunc } from '../../../rendering-commons/Sorting';
import { cssClassMap } from '../../../constants/SportCssMap';
var PopularLines = /** @class */ (function (_super) {
    __extends(PopularLines, _super);
    function PopularLines() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            itemsToggled: false
        };
        _this.onClick = function () {
            _this.setState({
                itemsToggled: !_this.state.itemsToggled
            });
        };
        return _this;
    }
    PopularLines.prototype.render = function () {
        var _a = this.props, sport = _a.sport, section = _a.section;
        var itemsToggled = this.state.itemsToggled;
        if (sport.get('eventCount') === 0)
            return null;
        var leagues = this.props.leagues.filter(function (league) { return sport.get('leagues').includes(league.get('id')); });
        var renderLeagues = [];
        if (itemsToggled) {
            leagues.sort(leagueSortFunc).map(function (league) {
                renderLeagues.push(_jsx(League, { id: league.get('id'), section: section }, league.get('id')));
            });
        }
        var sportCssName = cssClassMap[sport.get('id')];
        var sectionCls = itemsToggled ? 'section selected ' + sportCssName : 'section';
        return (_jsxs("div", __assign({ className: sectionCls }, { children: [_jsxs("div", __assign({ className: 'title toggle', onClick: this.onClick }, { children: [_jsx("img", { src: require("../../../assets/img/icons/".concat(sportCssName, ".svg")), alt: '' }), _jsxs("div", __assign({ className: 'name' }, { children: [sport.get('name'), " ", _jsx("span", __assign({ className: 'badge' }, { children: sport.get('eventCount') }))] }))] })), _jsx("div", __assign({ className: 'items toggle_content' }, { children: itemsToggled && renderLeagues }))] })));
    };
    PopularLines.propTypes = {
        section: PropTypes.string.isRequired,
        sport: PropTypes.object.isRequired
    };
    return PopularLines;
}(React.Component));
function mapStateToProps(state, props) {
    var section = props.section;
    var leagues = state.application.getIn([section, 'leagues']);
    return {
        leagues: leagues
    };
}
PopularLines = connect(mapStateToProps)(PopularLines);
export default PopularLines;



// WEBPACK FOOTER //
// ./src/components/grid/sports/PopularLines.jsx